"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkMergedTransactionSizeIsValid = exports.convertListToMap = void 0;
const common_sdk_1 = require("@orca-so/common-sdk");
;
function convertListToMap(fetchedData, addresses) {
    const result = {};
    fetchedData.forEach((data, index) => {
        if (data) {
            const addr = addresses[index];
            result[addr] = data;
        }
    });
    return result;
}
exports.convertListToMap = convertListToMap;
function checkMergedTransactionSizeIsValid(ctx, builders, latestBlockhash) {
    return __awaiter(this, void 0, void 0, function* () {
        const merged = new common_sdk_1.TransactionBuilder(ctx.connection, ctx.wallet);
        builders.forEach((builder) => merged.addInstruction(builder.compressIx(true)));
        try {
            const size = yield merged.txnSize({ latestBlockhash }); // throws if txnSize is too large
            return true;
        }
        catch (e) {
            return false;
        }
    });
}
exports.checkMergedTransactionSizeIsValid = checkMergedTransactionSizeIsValid;
